
(() => {
  function init() {
    const searchPage = document.querySelector('[data-fedko-search-url]');
    if (searchPage && location.pathname === searchPage.dataset.fedkoSearchUrl) {
      const cleanUrl = new URL(location.href);
      let resetPrice = false;
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach(key => {
        if (cleanUrl.searchParams.has(key)) { cleanUrl.searchParams.delete(key); resetPrice = true; }
      });
      if (['price-ascending', 'price-descending'].includes(cleanUrl.searchParams.get('sort_by'))) {
        cleanUrl.searchParams.delete('sort_by'); resetPrice = true;
      }
      if (resetPrice) {
        cleanUrl.searchParams.delete('page');
        location.replace(cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
        return;
      }
    }
    const params = new URLSearchParams(location.search);
    document.querySelectorAll('.contact__form').forEach(form => {
      const customer = form.querySelector('[data-fu-customer]');
      const category = form.querySelector('[data-fu-category]');
      const chosen = form.querySelector('[data-fu-selection]');
      const topic = form.querySelector('[name="contact[Anliegen]"]');
      if (customer && params.get('kundentyp') === 'b2b') customer.value = 'Geschäftskunde';
      const area = params.get('bereich');
      if (category && ['Bodenbeläge','Tische','Möbel','Saunen'].includes(area)) category.value = area;
      const selection = params.get('produkt');
      if (selection && chosen) { chosen.value = selection.slice(0,300); chosen.closest('label').hidden = false; }
      const quantity = form.querySelector('[name="contact[Menge]"]');
      if (quantity && params.get('menge')) quantity.value = params.get('menge').slice(0,100);
      const company = form.querySelector('[data-fu-company]');
      const updateCompany = () => { if (company && customer) company.hidden = customer.value !== 'Geschäftskunde'; };
      if (customer && !customer.dataset.fuReady) {
        customer.addEventListener('change',updateCompany);
        customer.dataset.fuReady = 'true';
      }
      updateCompany();
      if (topic && (selection || area || params.get('kundentyp') === 'b2b')) topic.value = 'Offerte / Beratung';
    });
    document.querySelectorAll('[data-fu-product-request]').forEach(link => {
      if (link.dataset.fuReady) return;
      link.dataset.fuReady = 'true';
      const productInfo = link.closest('.product__info');
      if (!productInfo) return;
      function updateRequest() {
        const options = [...productInfo.querySelectorAll('.product-form__option-selector')].map(group => {
          const control = group.querySelector('input[type="radio"]:checked, select');
          const name = group.querySelector('.product-form__option-name');
          return control && control.value !== 'Default Title' ? (name ? name.textContent.trim() + ' ' : '') + control.value : '';
        }).filter(Boolean);
        const target = new URL(link.href,location.origin);
        target.searchParams.set('produkt',[link.dataset.productTitle,...options].join(' · ').slice(0,300));
        const quantity = productInfo.querySelector('[name="quantity"]');
        if (quantity && quantity.value) target.searchParams.set('menge',quantity.value);
        link.href = target.pathname + target.search + target.hash;
      }
      productInfo.addEventListener('change',updateRequest);
      link.addEventListener('click',updateRequest);
      updateRequest();
    });
    function expandTarget() {
      let id; try { id = decodeURIComponent(location.hash.slice(1)); } catch (_) { return; }
      const target = document.getElementById(id);
      if (!target) return;
      let details = target.closest('details');
      const wasCollapsed = details && !details.open;
      while (details) { details.open = true; details = details.parentElement.closest('details'); }
      if (wasCollapsed) target.scrollIntoView({block:'start'});
    }
    expandTarget();
    window.addEventListener('hashchange',expandTarget);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
